import { useEffect, useState } from "react";

import { BASE_URL } from "../constants/constants";

const useRequestFunction = (endpoint, method = "GET", body) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const options = buildOptions(method, body);
    fetchData();

    async function fetchData() {
      try {
        const response = await fetch(`${BASE_URL}/${endpoint}`, options);

        if (response.status === 500) {
          setData({});
          console.log(response.status);
        }

        const body = await response.json();
        setData(body);
      } catch (err) {
        setData({});
        console.log(err);
      }
    }
  }, [endpoint, method, body]);
  return data;
};

const buildOptions = (method, body) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  if (body) return { method, headers, body: JSON.stringify(body) };

  return { method };
};

export default useRequestFunction;
